/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import LoanService from '../../services/LoanService';
import useForm from '../utils/useForm';
import createLoanInsuranceBillLabel from '../../helpers/forms/createLoanInsuranceBillLabel';

const useInsuranceBill = (onSubmit, loanId) => {
  const submitHandler = (formValues, actions) => {
    onSubmit(formValues);
    actions.resetForm();
  };

  const fields = useMemo(
    () => [
      {
        title: 'Add Bill',
        fields: [
          {
            title: 'Bill',
            name: 'bill_id',
            type: 'fetchableSelect',
            style: { gridColumn: '1 / 3' },
            fetchOptions: {
              key: ['loanBillOptions', loanId],
              queryFn: () =>
                LoanService.getLoanBills({
                  loanId,
                  type: 'Insurance',
                  status: null,
                  unassociatedWithInsurance: true,
                }),
              labelKey: createLoanInsuranceBillLabel,
            },
            required: true,
          },
        ],
      },
    ],
    [loanId]
  );

  return useForm({ fields, onSubmit: submitHandler });
};

export default useInsuranceBill;
